import axios from 'axios';
import { forEach as _forEach } from 'lodash';
import { InvoiceType, Operation } from '../../const/CancelModel';

export function simulate(pnrId) {
	return new Promise((resolve, reject) => {
		const CANCEL_URI = `/backoffice/api/v1/booking/${pnrId}/cancel/simulate`;
		axios
			.get(CANCEL_URI)
			.then((response) => {
				const result = response.data;
				_forEach(result.passengerInfo, (value, key) => {
					value.isReimbursable = response.data.passengerInfo[key].refundType === 'REFUNDABLE';
				});
				resolve(result);
			})
			.catch((error) => {
				reject(error);
			});
	});
}

export function cancel(
	tudoAzulNumber,
	payment,
	cancelSimulateModel,
	operation,
	exemptFeeParam = false,
	refundTaxOnlyParam = false
) {
	return new Promise((resolve, reject) => {
		const CANCEL_URI = '/backoffice/api/v1/booking';
		let cancelRequest = {};
		let amount = refundTaxOnlyParam ?
			cancelSimulateModel.simulation.invoice[InvoiceType[InvoiceType.TOTAL_PAYMENT]].value :
			cancelSimulateModel.simulation.invoice[InvoiceType[InvoiceType.BALANCE]].value;
		if (operation === Operation.REFUND) {
			cancelRequest = {
				pnrId: cancelSimulateModel.pnrId,
				refund: {
					amount: amount
				},
				tudoAzulNumber: `${tudoAzulNumber}`,
				exemptFee: exemptFeeParam,
				refundTaxOnly: refundTaxOnlyParam
			};
		} else {
			cancelRequest = {
				tudoAzulNumber: `${tudoAzulNumber}`,
				pnrId: cancelSimulateModel.pnrId,
				payment: {
					cardNumber: payment.cardNumber,
					vendorCode: payment.cardType.toUpperCase(),
					expiryMonth: payment.month,
					expiryYear: payment.year,
					cvv: payment.securityCode,
					ccHolderName: payment.name,
					amount: cancelSimulateModel.simulation.invoice[InvoiceType[InvoiceType.BALANCE]].value
				},
				exemptFee: exemptFeeParam,
				refundTaxOnly: refundTaxOnlyParam
			};
		}

		axios
			.patch(CANCEL_URI, cancelRequest,
				{
					headers: {
						RE: `${tudoAzulNumber}`
					}
				}
			)
			.then(response => {
				resolve();
			})
			.catch(error => {
				reject(error);
			});
	});
}

export function paymentEncrypted(
	tudoAzulNumber,
	payment,
	cancelSimulateModel,
	exemptFeeParam,
	cardEncrypted,
	refundTaxOnlyParam = false
) {

	return new Promise((resolve, reject) => {
		const CANCEL_URI = '/backoffice/api/v1/booking';
		const cancelRequest = {
			tudoAzulNumber: `${tudoAzulNumber}`,
			pnrId: cancelSimulateModel.pnrId,
			payment: {
				cardEncrypted,
				vendorCode: payment.cardType.toUpperCase(),
				amount: cancelSimulateModel.simulation.invoice[InvoiceType[InvoiceType.BALANCE]].value
			},
			exemptFee: exemptFeeParam,
			refundTaxOnly: refundTaxOnlyParam
		};

		axios
			.patch(CANCEL_URI, cancelRequest,
				{
					headers: {
						RE: `${tudoAzulNumber}`
					}
				}
			)
			.then(response => {
				resolve();
			})
			.catch(error => {
				reject(error);
			});
	});
}



// WEBPACK FOOTER //
// ./src/services/cancel/CancelService.js